<div class="user-management-page">

  <div class="page-body">
    <div class="user-management-card position-relative">
      <div *ngIf="loading || loadingForBrokerAdmin" class="table-loader">
        <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- ADMIN VIEW -->
      <mdb-tabs (activeTabChange)="getAdminUserList($event)" *ngIf="role === 'admin'" class="custom-tabs">

        <!-- FinTech Normal Users -->
        <mdb-tab title="FinTech Normal Users">
          <div class="tab-section">
            <div class="toolbar row g-3">
              <div class="col-12 col-md-4">
                <mdb-form-control>
                  <select [(ngModel)]="selectedFilter" ngDefaultControl class="form-select" aria-label="Filter users">
                    <option *ngFor="let filter of filters" [value]="filter.value">
                      {{ filter.name }}
                    </option>
                  </select>
                </mdb-form-control>
              </div>

              <div class="col-12 col-md-8">
                <mdb-form-control>
                  <input mdbInput type="search" id="searchNormalUsers" class="form-control" [(ngModel)]="filterText"
                    ngDefaultControl
                    (ngModelChange)="loadDetails(1, pa, selectedFilter, filterText, sortOrder, sortBy)" />
                  <label mdbLabel class="form-label" for="searchNormalUsers">Search</label>
                </mdb-form-control>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-hover align-middle"
                [ngClass]="loading || initialLoading ? 'blur-background' : ''">
                <thead>
                  <tr>
                    <th
                      (click)="sortBy = 'fullName'; loadDetails(1, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">
                      Full Name
                      <span
                        [ngClass]="{'arrow-up': sortBy === 'fullName' && sortOrder === 'ascending', 'arrow-down': sortBy === 'fullName' && sortOrder === 'descending'}"></span>
                    </th>
                    <th
                      (click)="sortBy = 'company'; loadDetails(1, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">
                      Company
                      <span
                        [ngClass]="{'arrow-up': sortBy === 'company' && sortOrder === 'ascending', 'arrow-down': sortBy === 'company' && sortOrder === 'descending'}"></span>
                    </th>
                    <th
                      (click)="sortBy = 'institution'; loadDetails(1, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">
                      Institution
                      <span
                        [ngClass]="{'arrow-up': sortBy === 'institution' && sortOrder === 'ascending', 'arrow-down': sortBy === 'institution' && sortOrder === 'descending'}"></span>
                    </th>
                    <th
                      (click)="sortBy = 'email'; loadDetails(1, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">
                      Email
                      <span
                        [ngClass]="{'arrow-up': sortBy === 'email' && sortOrder === 'ascending', 'arrow-down': sortBy === 'email' && sortOrder === 'descending'}"></span>
                    </th>
                    <th
                      (click)="sortBy = 'region'; loadDetails(1, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">
                      Region
                      <span
                        [ngClass]="{'arrow-up': sortBy === 'region' && sortOrder === 'ascending', 'arrow-down': sortBy === 'region' && sortOrder === 'descending'}"></span>
                    </th>
                    <th
                      (click)="sortBy = 'createdDate'; loadDetails(1, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">
                      Created Date
                      <span
                        [ngClass]="{'arrow-up': sortBy === 'createdDate' && sortOrder === 'ascending', 'arrow-down': sortBy === 'createdDate' && sortOrder === 'descending'}"></span>
                    </th>
                    <th class="text-end">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    *ngFor="let broker of brokerData | paginate: { itemsPerPage: itemsPerPage, currentPage: pa, totalItems: brokerResponse?.totalNoOfRecords, id:'broker' }">
                    <td class="shorten-text">{{ broker.fullName }}</td>
                    <td class="shorten-text">{{ broker.company }}</td>
                    <td class="shorten-text">{{ broker.institution }}</td>
                    <td class="shorten-text">{{ broker.email }}</td>
                    <td class="shorten-text">{{ broker.region }}</td>
                    <td class="shorten-text">{{ broker.createdDate }}</td>
                    <td class="text-end">
                      <div class="action-group">
                        <button type="button" class="btn btn-outline-info btn-sm"
                          (click)="viewBroker(broker)">More</button>
                        <div class="btn-group btn-group-sm" role="group">
                          <button type="button" class="btn btn-warning" (click)="openBrokerEditModal(broker)">
                            <i class="custom-icon-button1"></i>
                          </button>
                          <button type="button" class="btn btn-danger" (click)="openConfirmationModal(broker)">
                            <i class="custom-icon-button2"></i>
                          </button>
                          <button type="button" class="btn btn-info" (click)="openResetPasswordModal(broker)">
                            <i class="custom-icon-button3"></i>
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-footer">
              <div class="entries-control">
                <span>Entries per page</span>
                <div mdbDropdown class="dropdown">
                  <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton"
                    mdbDropdownToggle>
                    {{ itemsPerPage }}
                  </button>
                  <ul mdbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li><a class="dropdown-item" (click)="pageSizeChanged(10)">10</a></li>
                    <li><a class="dropdown-item" (click)="pageSizeChanged(20)">20</a></li>
                    <li><a class="dropdown-item" (click)="pageSizeChanged(50)">50</a></li>
                    <li><a class="dropdown-item" (click)="pageSizeChanged(100)">100</a></li>
                  </ul>
                </div>
              </div>

              <pagination-template id="broker" #p="paginationApi" (pageChange)="pageChanged($event)">
                <nav>
                  <ul class="pagination mb-0">
                    <li class="page-item" [ngClass]="p.isFirstPage() ? 'disabled' : ''">
                      <a (click)="p.previous()" class="page-link">Previous</a>
                    </li>

                    <ng-container *ngFor="let page of p.pages">
                      <li class="page-item" [ngClass]="p.getCurrent() === page.value ? 'active' : ''">
                        <a (click)="p.setCurrent(page.value)" class="page-link">{{ page.label }}</a>
                      </li>
                    </ng-container>

                    <li class="page-item" [ngClass]="p.isLastPage() ? 'disabled' : ''">
                      <a class="page-link" (click)="p.next()">Next</a>
                    </li>
                  </ul>
                </nav>
              </pagination-template>
            </div>
          </div>
        </mdb-tab>

        <!-- FinTech Broker Admin Users -->
        <mdb-tab title="FinTech Broker Admin Users">
          <div class="tab-section">
            <div class="toolbar row g-3">
              <div class="col-12 col-md-4">
                <mdb-form-control>
                  <select [(ngModel)]="selectedFilter" ngDefaultControl class="form-select"
                    aria-label="Filter admin brokers">
                    <option *ngFor="let filter of filters" [value]="filter.value">
                      {{ filter.name }}
                    </option>
                  </select>
                </mdb-form-control>
              </div>

              <div class="col-12 col-md-8">
                <mdb-form-control>
                  <input mdbInput type="search" id="searchBrokerAdmins" class="form-control" [(ngModel)]="filterText"
                    ngDefaultControl
                    (ngModelChange)="loadDetails(4, pa, selectedFilter, filterText, sortOrder, sortBy)" />
                  <label mdbLabel class="form-label" for="searchBrokerAdmins">Search</label>
                </mdb-form-control>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-hover align-middle"
                [ngClass]="loading || initialLoading ? 'blur-background' : ''">
                <thead>
                  <tr>
                    <th
                      (click)="sortBy = 'fullName'; loadDetails(4, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">Full Name</th>
                    <th
                      (click)="sortBy = 'company'; loadDetails(4, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">Company</th>
                    <th
                      (click)="sortBy = 'institution'; loadDetails(4, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">Institution</th>
                    <th
                      (click)="sortBy = 'email'; loadDetails(4, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">Email</th>
                    <th
                      (click)="sortBy = 'region'; loadDetails(4, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">Region</th>
                    <th
                      (click)="sortBy = 'createdDate'; loadDetails(4, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">Created Date</th>
                    <th class="text-end">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    *ngFor="let broker of adminBrokerData | paginate: { itemsPerPage: itemsPerPage, currentPage: pa, totalItems: adminBrokerResponse?.totalNoOfRecords, id:'brokerAdmin' }">
                    <td class="shorten-text">{{ broker.fullName }}</td>
                    <td class="shorten-text">{{ broker.company }}</td>
                    <td class="shorten-text">{{ broker.institution }}</td>
                    <td class="shorten-text">{{ broker.email }}</td>
                    <td class="shorten-text">{{ broker.region }}</td>
                    <td class="shorten-text">{{ broker.createdDate }}</td>
                    <td class="text-end">
                      <div class="action-group">
                        <button type="button" class="btn btn-outline-info btn-sm"
                          (click)="viewBroker(broker)">More</button>
                        <div class="btn-group btn-group-sm" role="group">
                          <button type="button" class="btn btn-warning" (click)="openBrokerEditModal(broker)"><i
                              class="custom-icon-button1"></i></button>
                          <button type="button" class="btn btn-danger" (click)="openConfirmationModal(broker)"><i
                              class="custom-icon-button2"></i></button>
                          <button type="button" class="btn btn-info" (click)="openResetPasswordModal(broker)"><i
                              class="custom-icon-button3"></i></button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-footer">
              <div class="entries-control">
                <span>Entries per page</span>
                <div mdbDropdown class="dropdown">
                  <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton2"
                    mdbDropdownToggle>
                    {{ itemsPerPage }}
                  </button>
                  <ul mdbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                    <li><a class="dropdown-item" (click)="pageSizeChangedForAdminBroker(10)">10</a></li>
                    <li><a class="dropdown-item" (click)="pageSizeChangedForAdminBroker(20)">20</a></li>
                    <li><a class="dropdown-item" (click)="pageSizeChangedForAdminBroker(50)">50</a></li>
                    <li><a class="dropdown-item" (click)="pageSizeChangedForAdminBroker(100)">100</a></li>
                  </ul>
                </div>
              </div>

              <pagination-template id="brokerAdmin" #p="paginationApi" (pageChange)="pageChangedForAdminBroker($event)">
                <nav>
                  <ul class="pagination mb-0">
                    <li class="page-item" [ngClass]="p.isFirstPage() ? 'disabled' : ''">
                      <a (click)="p.previous()" class="page-link">Previous</a>
                    </li>
                    <ng-container *ngFor="let page of p.pages">
                      <li class="page-item" [ngClass]="p.getCurrent() === page.value ? 'active' : ''">
                        <a (click)="p.setCurrent(page.value)" class="page-link">{{ page.label }}</a>
                      </li>
                    </ng-container>
                    <li class="page-item" [ngClass]="p.isLastPage() ? 'disabled' : ''">
                      <a class="page-link" (click)="p.next()">Next</a>
                    </li>
                  </ul>
                </nav>
              </pagination-template>
            </div>
          </div>
        </mdb-tab>

        <!-- Admin Users -->
        <mdb-tab title="Admin Users">
          <div class="tab-section">
            <div class="table-responsive">
              <table class="table table-hover align-middle"
                [ngClass]="loading || initialLoading ? 'blur-background' : ''">
                <thead>
                  <tr>
                    <th>Full Name</th>
                    <th>Profession</th>
                    <th>Email</th>
                    <th>Contact No</th>
                    <th class="text-end">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let admin of adminResponse">
                    <td>{{ admin.firstName }} {{ admin.lastName }}</td>
                    <td>{{ admin.profession }}</td>
                    <td>{{ admin.email }}</td>
                    <td>{{ admin.contactNo }}</td>
                    <td class="text-end">
                      <button type="button" class="btn btn-outline-info btn-sm" (click)="viewAdmin(admin)">More</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </mdb-tab>

        <!-- FinTech Internal Users -->
        <mdb-tab title="FinTech Internal Users">
          <div class="tab-section">
            <div class="toolbar row g-3">
              <div class="col-12 col-md-4">
                <mdb-form-control>
                  <select [(ngModel)]="selectedFilter" ngDefaultControl class="form-select"
                    aria-label="Filter internal users">
                    <option *ngFor="let filter of filtersForInternalUsers" [value]="filter.value">
                      {{ filter.name }}
                    </option>
                  </select>
                </mdb-form-control>
              </div>

              <div class="col-12 col-md-8">
                <mdb-form-control>
                  <input mdbInput type="search" id="searchInternalUsers" class="form-control" [(ngModel)]="filterText"
                    ngDefaultControl
                    (ngModelChange)="loadDetails(5, pa, selectedFilter, filterText, sortOrder, sortBy)" />
                  <label mdbLabel class="form-label" for="searchInternalUsers">Search</label>
                </mdb-form-control>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-hover align-middle"
                [ngClass]="loading || initialLoading ? 'blur-background' : ''">
                <thead>
                  <tr>
                    <th
                      (click)="sortBy = 'fullName'; loadDetails(5, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">Full Name</th>
                    <th
                      (click)="sortBy = 'institution'; loadDetails(5, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">Institution</th>
                    <th
                      (click)="sortBy = 'email'; loadDetails(5, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">Email</th>
                    <th
                      (click)="sortBy = 'region'; loadDetails(5, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">Region</th>
                    <th
                      (click)="sortBy = 'createdDate'; loadDetails(5, pa, selectedFilter, filterText, toggleSortDirection(), sortBy)"
                      class="header-button">Created Date</th>
                    <th class="text-end">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    *ngFor="let internalUser of internalUserData | paginate: { itemsPerPage: itemsPerPage, currentPage: pa, totalItems: internalUserResponse?.totalNoOfRecords, id:'internalUser' }">
                    <td class="shorten-text">{{ internalUser.fullName }}</td>
                    <td class="shorten-text">{{ internalUser.institution }}</td>
                    <td class="shorten-text">{{ internalUser.email }}</td>
                    <td class="shorten-text">{{ internalUser.region }}</td>
                    <td class="shorten-text">{{ internalUser.createdDate }}</td>
                    <td class="text-end">
                      <div class="action-group">
                        <button type="button" class="btn btn-outline-info btn-sm"
                          (click)="viewInternalUser(internalUser)">More</button>
                        <div class="btn-group btn-group-sm" role="group">
                          <button type="button" class="btn btn-warning" (click)="openBrokerEditModal(internalUser)"><i
                              class="custom-icon-button1"></i></button>
                          <button type="button" class="btn btn-danger" (click)="openConfirmationModal(internalUser)"><i
                              class="custom-icon-button2"></i></button>
                          <button type="button" class="btn btn-info" (click)="openResetPasswordModal(internalUser)"><i
                              class="custom-icon-button3"></i></button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-footer">
              <div class="entries-control">
                <span>Entries per page</span>
                <div mdbDropdown class="dropdown">
                  <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton3"
                    mdbDropdownToggle>
                    {{ itemsPerPage }}
                  </button>
                  <ul mdbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuButton3">
                    <li><a class="dropdown-item" (click)="pageSizeChangedForInternalUser(10)">10</a></li>
                    <li><a class="dropdown-item" (click)="pageSizeChangedForInternalUser(20)">20</a></li>
                    <li><a class="dropdown-item" (click)="pageSizeChangedForInternalUser(50)">50</a></li>
                    <li><a class="dropdown-item" (click)="pageSizeChangedForInternalUser(100)">100</a></li>
                  </ul>
                </div>
              </div>

              <pagination-template id="internalUser" #p="paginationApi"
                (pageChange)="pageChangedForInternalUser($event)">
                <nav>
                  <ul class="pagination mb-0">
                    <li class="page-item" [ngClass]="p.isFirstPage() ? 'disabled' : ''">
                      <a (click)="p.previous()" class="page-link">Previous</a>
                    </li>
                    <ng-container *ngFor="let page of p.pages">
                      <li class="page-item" [ngClass]="p.getCurrent() === page.value ? 'active' : ''">
                        <a (click)="p.setCurrent(page.value)" class="page-link">{{ page.label }}</a>
                      </li>
                    </ng-container>
                    <li class="page-item" [ngClass]="p.isLastPage() ? 'disabled' : ''">
                      <a class="page-link" (click)="p.next()">Next</a>
                    </li>
                  </ul>
                </nav>
              </pagination-template>
            </div>
          </div>
        </mdb-tab>
      </mdb-tabs>

      <!-- BROKER ADMIN VIEW -->
      <mdb-tabs (activeTabChange)="getBrokerAdminUserList($event)" *ngIf="role === 'brokerAdmin'" class="custom-tabs">
        <mdb-tab title="Institutional Normal Users">
          <div class="tab-section">
            <div class="toolbar row g-3">
              <div class="col-12 col-md-4">
                <mdb-form-control>
                  <select [(ngModel)]="selectedFilter" ngDefaultControl class="form-select"
                    aria-label="Filter institutional users">
                    <option *ngFor="let filter of filtersforNormalBrokers" [value]="filter.value">
                      {{ filter.name }}
                    </option>
                  </select>
                </mdb-form-control>
              </div>

              <div class="col-12 col-md-8">
                <mdb-form-control>
                  <input mdbInput type="search" id="searchInstitutionalUsers" class="form-control"
                    [(ngModel)]="filterText" ngDefaultControl
                    (ngModelChange)="loadBrokers(1, pa, selectedFilter, filterText, sortOrder, sortBy, institution)" />
                  <label mdbLabel class="form-label" for="searchInstitutionalUsers">Search</label>
                </mdb-form-control>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-hover align-middle"
                [ngClass]="loadingForBrokerAdmin || initialLoadingForBrokerAdmin ? 'blur-background' : ''">
                <thead>
                  <tr>
                    <th
                      (click)="sortBy = 'fullName'; loadBrokers(1, pa, selectedFilter, filterText, toggleSortDirection(), sortBy, institution)"
                      class="header-button">Full Name</th>
                    <th
                      (click)="sortBy = 'company'; loadBrokers(1, pa, selectedFilter, filterText, toggleSortDirection(), sortBy, institution)"
                      class="header-button">Company</th>
                    <th
                      (click)="sortBy = 'profession'; loadBrokers(1, pa, selectedFilter, filterText, toggleSortDirection(), sortBy, institution)"
                      class="header-button">Profession</th>
                    <th
                      (click)="sortBy = 'email'; loadBrokers(1, pa, selectedFilter, filterText, toggleSortDirection(), sortBy, institution)"
                      class="header-button">Email</th>
                    <th
                      (click)="sortBy = 'region'; loadBrokers(1, pa, selectedFilter, filterText, toggleSortDirection(), sortBy, institution)"
                      class="header-button">Region</th>
                    <th class="text-end">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    *ngFor="let broker of normalBrokerData | paginate: { itemsPerPage: itemsPerPage, currentPage: pa, totalItems: normalBrokerResponse?.totalNoOfRecords }">
                    <td class="shorten-text">{{ broker.fullName }}</td>
                    <td class="shorten-text">{{ broker.company }}</td>
                    <td class="shorten-text">{{ broker.profession }}</td>
                    <td class="shorten-text">{{ broker.email }}</td>
                    <td class="shorten-text">{{ broker.region }}</td>
                    <td class="text-end">
                      <div class="action-group">
                        <button type="button" class="btn btn-outline-info btn-sm"
                          (click)="viewNormalBroker(broker)">More</button>
                        <div class="btn-group btn-group-sm" role="group">
                          <button type="button" class="btn btn-warning" (click)="openNormalBrokerEditModal(broker)"><i
                              class="custom-icon-button1"></i></button>
                          <button type="button" class="btn btn-danger"
                            (click)="openNormalBrokerConfirmationModal(broker)"><i
                              class="custom-icon-button2"></i></button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-footer">
              <div class="entries-control">
                <span>Entries per page</span>
                <div mdbDropdown class="dropdown">
                  <button class="btn btn-primary btn-sm dropdown-toggle" type="button" mdbDropdownToggle>
                    {{ itemsPerPage }}
                  </button>
                  <ul mdbDropdownMenu class="dropdown-menu">
                    <li><a class="dropdown-item" (click)="pageSizeChangedForNormalBroker(10)">10</a></li>
                    <li><a class="dropdown-item" (click)="pageSizeChangedForNormalBroker(20)">20</a></li>
                    <li><a class="dropdown-item" (click)="pageSizeChangedForNormalBroker(50)">50</a></li>
                    <li><a class="dropdown-item" (click)="pageSizeChangedForNormalBroker(100)">100</a></li>
                  </ul>
                </div>
              </div>

              <pagination-template #p="paginationApi" (pageChange)="pageChangedForNormalBroker($event)">
                <nav>
                  <ul class="pagination mb-0">
                    <li class="page-item" [ngClass]="p.isFirstPage() ? 'disabled' : ''">
                      <a (click)="p.previous()" class="page-link">Previous</a>
                    </li>
                    <ng-container *ngFor="let page of p.pages">
                      <li class="page-item" [ngClass]="p.getCurrent() === page.value ? 'active' : ''">
                        <a (click)="p.setCurrent(page.value)" class="page-link">{{ page.label }}</a>
                      </li>
                    </ng-container>
                    <li class="page-item" [ngClass]="p.isLastPage() ? 'disabled' : ''">
                      <a class="page-link" (click)="p.next()">Next</a>
                    </li>
                  </ul>
                </nav>
              </pagination-template>
            </div>
          </div>
        </mdb-tab>

        <mdb-tab title="Institutional Admin Users">
          <div class="tab-section">
            <div class="table-responsive">
              <table class="table table-hover align-middle"
                [ngClass]="loadingForBrokerAdmin || initialLoadingForBrokerAdmin ? 'blur-background' : ''">
                <thead>
                  <tr>
                    <th>Full Name</th>
                    <th>Profession</th>
                    <th>Email</th>
                    <th>Contact No</th>
                    <th class="text-end">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let admin of brokerAdminResponse">
                    <td>{{ admin.firstName }} {{ admin.lastName }}</td>
                    <td>{{ admin.profession }}</td>
                    <td>{{ admin.email }}</td>
                    <td>{{ admin.contactNo }}</td>
                    <td class="text-end">
                      <button type="button" class="btn btn-outline-info btn-sm" (click)="viewAdmin(admin)">More</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </mdb-tab>
      </mdb-tabs>
    </div>
  </div>
</div>

<div class="app-registration-popup" *ngIf="isUserManagement">
  <button class="btn btn-primary chat-btn" (click)="openRegistrationModal()"></button>
</div>